/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpgatesAddonProvisionProject200Response
 */
export interface UpgatesAddonProvisionProject200Response {
    /**
     * 
     * @type {boolean}
     * @memberof UpgatesAddonProvisionProject200Response
     */
    error?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonProvisionProject200Response
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonProvisionProject200Response
     */
    projectId?: string | null;
}

/**
 * Check if a given object implements the UpgatesAddonProvisionProject200Response interface.
 */
export function instanceOfUpgatesAddonProvisionProject200Response(value: object): value is UpgatesAddonProvisionProject200Response {
    return true;
}

export function UpgatesAddonProvisionProject200ResponseFromJSON(json: any): UpgatesAddonProvisionProject200Response {
    return UpgatesAddonProvisionProject200ResponseFromJSONTyped(json, false);
}

export function UpgatesAddonProvisionProject200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgatesAddonProvisionProject200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
        'message': json['message'] == null ? undefined : json['message'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
    };
}

export function UpgatesAddonProvisionProject200ResponseToJSON(json: any): UpgatesAddonProvisionProject200Response {
    return UpgatesAddonProvisionProject200ResponseToJSONTyped(json, false);
}

export function UpgatesAddonProvisionProject200ResponseToJSONTyped(value?: UpgatesAddonProvisionProject200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
        'message': value['message'],
        'projectId': value['projectId'],
    };
}

